export { MIN_REMARKS_LENGTH, RATING_CONTENT_MAX_WIDTH } from '../rlhfShared/constants';

/** Shared constants for the RLHF rating workbench. */

export const RATING_SCALE = [1, 2, 3, 4, 5] as const;

/**
 * The rubric, rendered under each button rather than hidden in a tooltip — raters shouldn't
 * have to hover to learn what a 3 means, and a visible scale is what keeps scoring consistent
 * between people and across sessions.
 */
export const RATING_LABELS: Record<number, string> = {
  1: 'Very weak',
  2: 'Weak',
  3: 'Adequate',
  4: 'Strong',
  5: 'Excellent',
};

/** Longer gloss on each rubric point, shown on hover and to screen readers. */
export const SCALE_HINTS: Record<number, string> = {
  1: 'Very weak — wrong, fabricated, or unusable',
  2: 'Weak — misses most of what was asked',
  3: 'Adequate — partly answers it',
  4: 'Strong — answers the ask with support',
  5: 'Excellent — answers fully, well evidenced',
};
